export const GET_LIST_DANHSACHDONHANG = "GET_LIST_DANHSACHDONHANG";
export const GET_LIST_DANHSACHDONHANG_SUCCESS = "GET_LIST_DANHSACHDONHANG_SUCCESS";
export const GET_LIST_DANHSACHDONHANG_FAILURE = "GET_LIST_DANHSACHDONHANG_FAILURE";

export const UPDATE_SEARCHTDATA_DANHSACHDONHANG = "UPDATE_SEARCHTDATA_DANHSACHDONHANG";
export const UPDATE_DANHSACHDONHANG = "UPDATE_DANHSACHDONHANG";
